import { BlockStatusProps } from 'Models/LoanBff';
import { DOMAIN, LoggerFactory } from 'Services/Logger';

import GenericBffClient from 'Utils/httpClients/GenericBffClient';
import { mapToAurora } from 'Utils/mapToAurora';

const logger = LoggerFactory.getLogger(DOMAIN.KUESKI);
export class LoanBFFConfig extends GenericBffClient {
  constructor() {
    super('LOAN_BFF_URL', '/api/v1/', { logger });
  }

  async validateBlockUserStatus(): Promise<BlockStatusProps> {
    const raw = await this.get('clients/block_status');
    return mapToAurora(raw) as BlockStatusProps;
  }
}
